import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'kt-select-error-dialog',
  templateUrl: './select-error-dialog.component.html',
  styleUrls: ['./select-error-dialog.component.scss'],
})
export class SelectErrorDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SelectErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
  public static errorsOptions = [
    {
      value: '1',
      label: 'Dispense drug',
    },
    {
      value: '2',
      label: 'Prescribe drug',
    },
    {
      value: '3',
      label: 'Quantity',
    },
    {
      value: '4',
      label: 'Sig',
    },
    {
      value: '5',
      label: 'Doctor',
    },
    {
      value: '6',
      label: 'Patient',
    },
    {
      value: '7',
      label: 'Insurance',
    },
    {
      value: '8',
      label: 'No stocks',
    },
    {
      value: '9',
      label: 'Pharmacist preference',
    },
    {
      value: '10',
      label: 'Others',
    },
    {
      value: '11',
      label: 'HOA',
    },
    {
      value: '12',
      label: 'Rx Origin',
    },
    {
      value: '13',
      label: 'Written date',
    },
    {
      value: '14',
      label: 'Delivery Schedule',
    },
  ];
  control = new FormControl('', [Validators.required]);
  note = new FormControl('', [Validators.required]);

  errorsOptions = SelectErrorDialogComponent.errorsOptions;

  save() {
    if (this.control.valid && this.note.valid) {
      this.dialogRef.close({ value: this.control.value, note: this.note.value });
    } else {
      this.control.markAllAsTouched();
      this.note.markAllAsTouched();
    }
  }
}
